export default __webpack_public_path__ + "static/media/Hit_placement-12.1f44e9cb.png";